import { combineReducers } from "@reduxjs/toolkit";
import { templateReducer } from "./templateReducer";

export const rootReducer = combineReducers({
  template: templateReducer,
});
